import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import { FaHome, FaHeart } from 'react-icons/fa';
import Logo from './Logo';

const NotFound = () => {
  usePageTitle('Page Not Found');
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center">
      <div className="relative z-10 text-center px-4">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="max-w-2xl mx-auto"
        >
          {/* Logo */}
          <motion.div variants={itemVariants} className="mb-8 text-center">
            {/* <Logo size="large" className="mb-6 justify-center" /> */}
            <img src="/assets/png-logo.png" className="w-40 mx-auto" alt="" />
          </motion.div>

          {/* 404 Message */}
          <motion.div variants={itemVariants} className="mb-8">
            <h1 className="text-6xl md:text-8xl font-bold text-white mb-4">
              4<span className="gradient-text">0</span>4
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Oops! Page Not Found
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Looks like this page went on a date and never came back! 
              Don't worry, there are plenty of other pages in the sea.
            </p>
          </motion.div>

          {/* Action Buttons */}
          <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                to="/"
                className="bg-gradient-to-r from-romantic-purple to-romantic-pink text-white px-8 py-4 rounded-full font-semibold text-lg flex items-center gap-3 shadow-lg"
              >
                <FaHome />
                Back to Home
              </Link>
            </motion.div>
            
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                to="/terms"
                className="bg-gradient-to-r from-romantic-blue to-romantic-purple text-white px-8 py-4 rounded-full font-semibold text-lg flex items-center gap-3 shadow-lg"
              >
                <FaHeart />
                Find Love Instead
              </Link>
            </motion.div>
          </motion.div>

          {/* Fun Animation */}
          <motion.div
            variants={itemVariants}
            className="mt-12"
            animate={{
              y: [0, -10, 0],
              rotate: [0, 5, -5, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <div className="text-6xl">💔</div>
            <p className="text-gray-400 mt-2">Even our 404 page needs love!</p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
